import request from '@/utils/service'

export function addSiteApi(data) {
  return request({
    url: '/store/addNew',
    method: 'post',
    data
  })
}

export function updateSiteApi(data) {
  return request({
    url: '/store/updateNew',
    method: 'post',
    data
  })
}

export function delSiteApi(data) {
  return request({
    url: '/store/delete',
    method: 'post',
    data
  })
}

export function siteListApi(data) {
  return request({
    url: '/store/list',
    method: 'get',
    params: data
  })
}

export function findDeviceApl(data) {
  return request({
    url: '/store/findDevice',
    method: 'get',
    params: data
  })
}

export function bindEquApi(data) {
  return request({
    url: '/store/bindDevice',
    method: 'post',
    data
  })
}

export function bindNewEquApi(data) {
  return request({
    url: '/store/newBindDevice',
    method: 'post',
    data
  })
}

export function unBindEquApi(data) {
  return request({
    url: '/store/unbindDevice',
    method: 'post',
    data
  })
}

// 网点类型
export function siteTypeApi(data) {
  return request({
    url: '/storeType/list',
    method: 'get',
    params: data
  })
}

export function delSiteTypeApi(data) {
  return request({
    url: '/storeType/delete    ',
    method: 'post',
    data
  })
}

export function addTypeApi(data) {
  return request({
    url: '/storeType/add',
    method: 'post',
    data
  })
}

export function updateTypeApi(data) {
  return request({
    url: '/storeType/update',
    method: 'post',
    data
  })
}

export function updateStatus(data) {
  return request({
    url: '/store/updateStatus',
    method: 'post',
    data
  })
}

// 修改是否为公司资产状态
export function updateCompanyAssets(data) {
  return request({
    url: '/store/updateCompanyAssets',
    method: 'post',
    data
  })
}

// 重启全部设备
export function rebootEquApi(data) {
  return request({
    url: '/device/restartByStore',
    method: 'post',
    data
  })
}

// 重启单个设备
export function rebootSingleEquApi(data) {
  return request({
    url: '/device/restartBySn',
    method: 'post',
    data
  })
}

// 设置语音
export function voiceSettingByStore(data) {
  return request({
    url: '/device/voiceSettingByStore',
    method: 'post',
    data
  })
}

export function allSiteList(name) {
  return request({
    url: `/store/selectStoreList/${name}`,
    method: 'get'
  })
}
